/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";
import { Subject } from "./subject";

export class SubjectProject extends Subject implements Serializable<SubjectProject> {
    projectName: string;
    // location: string;
    projectStartDate: any;
    description: string;

    projectType: any;
    projectTypeId: any;

    teamRoleId: any;
    teamRole: any;

    prevTeamRoleId: any;
    prevProjectTypeId: any;

    projectId: number;// 12345,
    // loading: any; // for frontend
    // firstName: string; //////“James”,
    // lastName: string;// “Doe”,
    // middleName: string;
    // lastNameTemp: string;
    // gender: string;/// “male”,
    // gradeLevel: number;//“5”,
    // school: string;//“Nathan Hale Elementary School”,
    // photo: string;
    // photoMimeType: string;
    // orgBirthDate: any;//“2005-01-01T00:00:00.000Z”, // in UTC
    // birthDate: any;//“2005-01-01T00:00:00.000Z”, // in UTC
    // providers: Provider[];
    // teamMembers: User[] = [];
    // resource: any;
    // age: any;
    // relation: string;

    // prevTeamRoleId: any;
    // parent: User;
    // ownerId;
    // tempPhoto: string;
    // isFrozen: boolean = false;
    // isFormerTeamMember: boolean = false;
    // frozenDate: any;
    // invitation: Invitation;
    // careTeamActions: [];
    // bgColor: string;
    // exitDate: Date;
    // showFormerTeamMembers: boolean = false;
    // allowEdit: boolean = false;
    // coCaptain: boolean = false;

    // birthDateShort: any;
    // month;
    // day;
    // year;
    // date;
    // initialName: string;

    // updateAge = function () {

    //     var today = new Date();
    //     var birthDate = new Date(this.birthDate);
    //     var age = today.getFullYear() - birthDate.getFullYear();
    //     var m = today.getMonth() - birthDate.getMonth();
    //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //         age--;
    //     }
    //     this.age = age;

    //     //this.ageText = false;
    //     if (this.age > 1) {
    //         this.ageText = this.age + ' Years old';
    //     } else {

    //         var m = moment().diff(moment(this.birthDate), 'months')
    //         if (m) {
    //             if (m < 12) {
    //                 this.ageText = m + ' Month' + (m == 1 ? '' : 's') + ' old';
    //             } else {
    //                 this.ageText = '1 Year old';
    //             }
    //         } else {
    //             var d = moment().diff(moment(this.birthDate), 'days')
    //             this.ageText = d + ' Day' + (d == 1 ? '' : 's') + ' old';
    //         }
    //     }
    // };


    // getAgeText = () => {
    //     if (!!this.ageText) {
    //         // do nothing
    //     } else {
    //         this.ageText = this._getAgeText();
    //     }

    //     return this.ageText;
    // }

    // _getAgeText = () => {
    //     if (!this.age) {
    //         this.updateAge();
    //     }
    //     if (this.age > 1) {
    //         return this.age + ' Years old';
    //     } else {

    //         var m = moment().diff(moment(this.birthDate), 'months')
    //         if (m) {
    //             if (m < 12) {
    //                 return m + ' Month' + (m == 1 ? '' : 's') + ' old';
    //             } else {
    //                 return '1 Year old';
    //             }
    //         } else {
    //             var d = moment().diff(moment(this.birthDate), 'days')
    //             return d + ' Day' + (d == 1 ? '' : 's') + ' old';
    //         }
    //     }
    // }

    getTeamMembers = () => {

    }



    // fullName;
    // public _fullName() {
    //     this.fullName = this.firstName + ' ' + (this.middleName ? (this.middleName + ' ') : '') + this.lastName;
    // }

    // parentFirstName;

    // parentLastName;



    // this will be used for casting JSON to object
    deserialize(input) {
        super.deserialize(input);

        // if (input.projectName) {
        //     this.initialName = input.firstName.charAt(0).toUpperCase();
        // }
        // if (input.lastName) {
        //     this.initialName += input.lastName.charAt(0).toUpperCase();
        // }
        if (!input.projectId && !input._id) return;
        if (input._id)
            this.projectId = input._id;// 12345,
        else
            this.projectId = input.projectId;// 12345,
        this.projectName = input.projectName;
        this.projectStartDate = input.projectStartDate;
        // this.location = input.location;
        this.description = input.description;

        input.teamRoleId && (this.teamRoleId = input.teamRoleId);
        input.teamRoleId && (this.prevTeamRoleId = input.teamRoleId);
        input.teamRole && (this.teamRole = input.teamRole);
        input.prevTeamRoleId && (this.prevTeamRoleId = input.prevTeamRoleId);


        input.projectTypeId && (this.projectTypeId = input.projectTypeId);
        input.projectTypeId && (this.prevProjectTypeId = input.projectTypeId);
        input.projectType && (this.projectType = input.projectType);
        input.prevProjectTypeId && (this.prevProjectTypeId = input.prevProjectTypeId);

        return this;

    }

    update(input: any) {
        super.update(input);

        if (!!input) {
            !!input.projectType && (this.projectType = input.projectType);
            !!input.projectName && (this.projectName = input.projectName);
            !!input.projectStartDate && (this.projectStartDate = input.projectStartDate);
            !!input.description && (this.description = input.description);
            !!input.projectTypeId && (this.projectTypeId = input.projectTypeId);
            !!input.teamRoleId && (this.teamRoleId = input.teamRoleId);
            !!input.teamRole && (this.teamRole = input.teamRole);
            !!input.prevTeamRoleId && (this.prevTeamRoleId = input.prevTeamRoleId);
            !!input.prevProjectTypeId && (this.prevProjectTypeId = input.prevProjectTypeId);
            !!input.projectId && (this.projectId = input.projectId);

        }
    }

    constructor() {
        super();
        // The below data is test data

    }


    getObject(id) {
        this.subjectId = id;

        return this;
    }


}
